
            const data = {"name":"feather/file-text","data":{"width":"24","height":"24","viewBox":"0 0 24 24","data":"<path pid=\"0\" d=\"M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z\"/><path pid=\"1\" d=\"M14 2v6h6M16 13H8M16 17H8M10 9H8\"/>","originalColors":[],"stopColors":[]}}
        
                module.exports = data
                